import React, { useEffect, useState } from "react";
import { Typography, Row, Col, Alert, Button } from "antd";
import {
  useAppDetection,
  useErrorDialog,
  useChromeExtensionDetection,
  useSteps,
  useLogger,
} from "hooks";

const { Paragraph, Title } = Typography;

/**
 * The chrome app store prompts.
 *
 * @returns jsx
 */
const AppStore = () => {
  return (
    <>
      <Row type="flex" justify="center">
        <Col span={16}>
          <Title className="text-start" level={5}>
            A Chrome extension must be installed.
          </Title>
          <Title className="text-start" level={5}>
            The extension is:
          </Title>
          <ul className="text-start">
            <li>Entirely safe to run.</li>
            <li>Easy to uninstall.</li>
          </ul>
          <Button
            type="primary"
            href="https://chrome.google.com/webstore/detail/detection-app-from-system/jmojbongkkefmnnpnojfgaipjdmllgma/related?hl=en&authuser=0"
            target="_blank"
          >
            App Store
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default AppStore;
